@if (shouldRender) {
  <div class="paginator-wr">
    @if (showCurrentPageReport) {
      <div class="paginator-info">
        <span class="info-text">{{ reportText }}</span>
      </div>
    }
    <div class="paginator-controls">
      @if (showFirstLastIcon) {
        <button type="button" class="control-btn first-btn" (click)="goToFirstPage()" [disabled]="disabled || isFirstPage" [attr.aria-label]="'PAGINATOR.BTN_FIRST' | translate">
          <span class="button-text sr-only">{{ 'PAGINATOR.BTN_FIRST' | translate }}</span>
        </button>
      }
      <button type="button" class="control-btn prev-btn" (click)="goToPreviousPage()"
        [disabled]="disabled || isFirstPage" [attr.aria-label]="'PAGINATOR.BTN_PREVIOUS' | translate">
        <span class="button-text sr-only">{{ 'PAGINATOR.BTN_PREVIOUS' | translate }}</span>
      </button>
      @if (showPageLinks && visiblePageNumbers.length) {
        <div class="page-numbers">
          @for (visiblePageNumber of visiblePageNumbers; track visiblePageNumber) {
            <button type="button" class="page-number-btn"
              [class.active]="currentPageNumber === visiblePageNumber" [disabled]="disabled"
              (click)="onPageNumberClick(visiblePageNumber)" [attr.aria-label]="'Go to page ' + visiblePageNumber"
              [attr.aria-current]="currentPageNumber === visiblePageNumber ? 'page' : null">
              {{ visiblePageNumber }}
            </button>
          }
        </div>
      }
      <button type="button" class="control-btn next-btn" (click)="goToNextPage()" [disabled]="disabled || isLastPage" [attr.aria-label]="'PAGINATOR.BTN_NEXT' | translate">
        <span class="button-text sr-only">{{ 'PAGINATOR.BTN_NEXT' | translate }}</span>
      </button>
      @if (showFirstLastIcon) {
        <button type="button" class="control-btn last-btn" (click)="goToLastPage()" [disabled]="disabled || isLastPage" [attr.aria-label]="'PAGINATOR.BTN_LAST' | translate">
          <span class="button-text sr-only">{{ 'PAGINATOR.BTN_LAST' | translate }}</span>
        </button>
      }
    </div>
    @if (showPageSizeSelector && rowsPerPageOptions.length) {
      <div class="page-size-selector">
        <label class="page-size-label" [for]="pageSizeSelectId">{{ 'PAGINATOR.ITEMS_PER_PAGE' | translate }}:</label>
        <select class="page-size-dropdown" [id]="pageSizeSelectId" [ngModel]="currentRows"
          [ngModelOptions]="{ standalone: true }" [disabled]="disabled"
          [attr.aria-label]="'PAGINATOR.ITEMS_PER_PAGE' | translate" (ngModelChange)="onRowsChange($event)">
          @for (size of rowsPerPageOptions; track size) {
            <option [ngValue]="size">
              {{ size }}
            </option>
          }
        </select>
      </div>
    }
  </div>
}
